// import Home from "../views/Home.vue";
// import AboutUs from "../../aboutUs/views/AboutUs.vue";
// import FAQ from "../../FAQ/views/Faq.vue";
// import ContactUs from "../../contactUs/views/ContactUs.vue";
// import UserDashboard from "../../userdashboard/views/Dashboard.vue";


const Home = () => import('../views/Home.vue');

const AboutUs = () => import('../../aboutUs/views/AboutUs.vue');

const HowItWorks = () => import('../../aboutUs/views/HowItWorks.vue');

const FAQ = () => import('../../FAQ/views/Faq.vue');

const ContactUs = () => import('../../contactUs/views/ContactUs.vue');

const UserDashboard = () => import('../../userdashboard/views/Dashboard.vue');

const Event = () => import('../../Events/views/Event');


export default [{
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/dashboard",
        name: "UserDashboard",
        component: UserDashboard,
    },
    {
        path: "/landing",
        name: "Shop",
        component: Home,
    },
    {
        path: "/landing",
        name: "RFP",
        component: Home,
    },
    {
        path: "/about-us",
        name: "About Us",
        component: AboutUs,
    },
    {
        path: "/how-it-works",
        name: "How It Works",
        component: HowItWorks,
    },
    {
        path: "/help-center",
        name: "Help",
        component: FAQ,
    },
    {
        path: "/contact-us",
        name: "Contact Us",
        component: ContactUs,
    },
    {
        path: "/listRfp",
        name: "listRfp",
        component: Home
    },
    {
        path: "/events",
        name: "events",
        component: Event,
     
    },
];